import { render, staticRenderFns } from "./IncomingNotificationPanel.vue?vue&type=template&id=c6a210ee&scoped=true"
import script from "./IncomingNotificationPanel.vue?vue&type=script&lang=js"
export * from "./IncomingNotificationPanel.vue?vue&type=script&lang=js"
import style0 from "./IncomingNotificationPanel.vue?vue&type=style&index=0&id=c6a210ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a210ee",
  null
  
)

export default component.exports